import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["closedIcon", "openIcon"];

  initialize() {
    this.isOpen = false;
  }

  connect() {
    this.element.addEventListener("focusout", this.handleFocusOut.bind(this));
  }

  disconnect() {
    this.element.removeEventListener(
      "focusout",
      this.handleFocusOut.bind(this),
    );
    this.isOpen = false;
  }

  toggle(_event) {
    if (this.isOpen) {
      this.isOpen = false;
      document.activeElement.blur();
    } else {
      this.isOpen = true;
      this.toggleIcons();
    }
  }

  handleFocusOut() {
    this.isOpen = false;
    this.toggleIcons();
  }

  toggleIcons() {
    if (this.hasClosedIconTarget) {
      this.closedIconTarget.classList.toggle("hidden");
      this.openIconTarget.classList.toggle("hidden");
    }
  }
}
